import { render, staticRenderFns } from "./UiColorPicker.vue?vue&type=template&id=168b2099&"
import script from "./UiColorPicker.vue?vue&type=script&lang=js&"
export * from "./UiColorPicker.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports